<template>
  <div class="d-flex justify-content-between align-items-center">
    <span>{{ $t('app.mute-notifications') }}</span>
    <b-form-checkbox
      :checked="muted"
      class="custom-control-primary"
      name="check-button"
      switch
      @change="handleChange"
    />
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BFormCheckbox,
  },
  data() {
    return { muted: false }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  mounted() {
    this.muted = !!this.user.muted_notifications
  },
  methods: {
    handleChange() {
      this.muted = !this.muted
      this.$store.dispatch('auth/TOGGLE_NOTIFICATIONS', { muted_notifications: this.muted })
    },
  },
}
</script>

<style scoped>

</style>
